import { render, staticRenderFns } from "./workbench1.vue?vue&type=template&id=5b149852&scoped=true"
import script from "./workbench1.vue?vue&type=script&lang=js"
export * from "./workbench1.vue?vue&type=script&lang=js"
import style0 from "./workbench1.vue?vue&type=style&index=0&id=5b149852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b149852",
  null
  
)

export default component.exports